import React from 'react';
import type { SeparateComponentProps } from './separate-interface.interfaces';

export function SeparateInterfaceComponent(props: SeparateComponentProps) {
  const { userId, services } = props;
  
  React.useEffect(() => {
    services.api.getUserData(userId).then(data => {
      services.logger.log(`Loaded user ${userId}`);
      services.cache?.set(`user-${userId}`, data);
    });
  }, [userId]);

  return <div>User ID: {userId}</div>;
}
